import * as React from "react";
import styled from "styled-components";

import { useParams } from "@opendash/router";
import { Typography, message } from "antd";

import { useAppState } from "../state";
import { AppLayout } from "./AppLayout";
import { useTranslation } from "@opendash/i18n";

const tips = new Array(22).fill(0).map((v, index) => index + 1);

const ContentBox = styled.div`
  padding: 20px;
`;

const TipsBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;

  margin-top: 30px;

  font-size: 16px;

  @media only screen and (min-width: 800px) {
    font-size: 18px;
  }
`;

const TipBox = styled.div`
  margin-bottom: 40px;
  width: 100%;

  @media only screen and (min-width: 800px) {
    width: calc(50% - 20px);
  }
`;

const TipHeadBox = styled.div`
  font-weight: bold;
  margin-bottom: 10px;

  @media only screen and (min-width: 800px) {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }

  @media only screen and (min-width: 1200px) {
    font-size: 20px;
  }
`;

const TipNumberBox = styled.div`
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.1);

  margin-bottom: 6px;

  @media only screen and (min-width: 800px) {
    margin-bottom: 0px;
  }

  @media only screen and (min-width: 1200px) {
    height: 60px;
    width: 60px;
    line-height: 60px;
  }
`;

const TipTitleBox = styled.div`
  @media only screen and (min-width: 800px) {
    line-height: 40px;
  }

  @media only screen and (min-width: 1200px) {
    line-height: 60px;
  }
`;

const TipDescriptionBox = styled.div``;

export const EnergySavingTipsRoute = React.memo(
  function EnergySavingTipsRoute() {
    const t = useTranslation();
    const { videos } = useAppState();

    const { id } = useParams();

    const selectedVideo = videos.find((video) => video.id === id);

    React.useEffect(() => {
      if (id && !selectedVideo) {
        message.error(t("app:videos.error_not_found"));
      }
    }, [id, selectedVideo]);

    return (
      <AppLayout>
        <ContentBox>
          <Typography.Title level={3}>
            {t("app:energy_saving_tips.title")}
          </Typography.Title>
          <TipsBox>
            {tips.map((tip) => {
              const title = t(`app:energy_saving_tips.tip_${tip}_title`);
              const description = t(
                `app:energy_saving_tips.tip_${tip}_description`
              );

              return (
                <TipBox key={tip}>
                  <TipHeadBox>
                    <TipNumberBox>#{tip}</TipNumberBox>
                    <TipTitleBox>{title}</TipTitleBox>
                  </TipHeadBox>
                  <TipDescriptionBox>{description}</TipDescriptionBox>
                </TipBox>
              );
            })}
          </TipsBox>
        </ContentBox>
      </AppLayout>
    );
  }
);
